var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "grid-view" },
    [
      _c("div", { staticClass: "main-content" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.pageMode === 0,
                expression: "pageMode === 0"
              }
            ],
            staticStyle: { width: "100%", height: "100%" }
          },
          [
            _c(
              "bank-slip-query",
              {
                ref: "bankSlipWriteOff",
                attrs: {
                  identify: "bankSlipWriteOff",
                  "view-source": "bankSlipWriteOff",
                  "config-module": "1200",
                  "is-ar": _vm.searchConditions.applicationStatus,
                  "is-claim": true,
                  "check-role": false,
                  "ar-field": "ar",
                  "total-type": "revenueAbs",
                  "page-mode": _vm.pageMode,
                  "grid-config-module": "1200002"
                },
                scopedSlots: _vm._u([
                  {
                    key: "searchAreaHeader",
                    fn: function() {
                      return [
                        _c(
                          "div",
                          {
                            staticClass:
                              "app-main-inner-row  extension-conditions-form",
                            staticStyle: {
                              "padding-bottom": "5px",
                              "margin-top": "-7px"
                            }
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "filters" },
                              [
                                _c(
                                  "el-form",
                                  {
                                    attrs: {
                                      inline: true,
                                      "label-position": "left"
                                    }
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "el-form-item-wrapper dense-radio-group"
                                      },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            staticClass: "dense-radio-group",
                                            attrs: {
                                              label: _vm.$t(
                                                "CargoMsg.Cargo_PaymentReceiveMethod"
                                              )
                                            }
                                          },
                                          [
                                            _c(
                                              "el-radio-group",
                                              {
                                                model: {
                                                  value:
                                                    _vm.searchConditions
                                                      .applicationStatus,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.searchConditions,
                                                      "applicationStatus",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "searchConditions.applicationStatus"
                                                }
                                              },
                                              [
                                                _c(
                                                  "el-radio",
                                                  {
                                                    attrs: {
                                                      disabled: !(
                                                        _vm.bankArSlip &&
                                                        _vm.bankApSlip
                                                      ),
                                                      label: -1
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "CargoMsg.Cargo_All"
                                                        )
                                                      )
                                                    )
                                                  ]
                                                ),
                                                _c(
                                                  "el-radio",
                                                  {
                                                    attrs: {
                                                      disabled: !_vm.bankArSlip,
                                                      label: 1
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "CargoMsg.Cargo_Receivable"
                                                        )
                                                      )
                                                    )
                                                  ]
                                                ),
                                                _c(
                                                  "el-radio",
                                                  {
                                                    attrs: {
                                                      disabled: !_vm.bankApSlip,
                                                      label: 0
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "CargoMsg.Cargo_Dues"
                                                        )
                                                      )
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ]
                        )
                      ]
                    },
                    proxy: true
                  }
                ])
              },
              [
                _c(
                  "div",
                  { attrs: { slot: "operations" }, slot: "operations" },
                  [
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.$checkPermission([
                              "button_fmBankSlip_bankSlipWriteOff"
                            ]),
                            expression:
                              "$checkPermission(['button_fmBankSlip_bankSlipWriteOff'])"
                          }
                        ],
                        attrs: { type: "primary" },
                        on: { click: _vm.writeOffClickHandler }
                      },
                      [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ClaimAR")))]
                    ),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.$checkPermission([
                              "button_fmBankSlip_bankSlipWriteOff"
                            ]),
                            expression:
                              "$checkPermission(['button_fmBankSlip_bankSlipWriteOff'])"
                          }
                        ],
                        attrs: { type: "primary" },
                        on: { click: _vm.preWriteOffClickHandler }
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("CargoMsg.Cargo_ClaimAdvanceReceipt"))
                        )
                      ]
                    )
                  ],
                  1
                )
              ]
            )
          ],
          1
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.pageMode !== 0,
                expression: "pageMode !== 0"
              }
            ],
            staticStyle: { width: "100%", height: "100%" }
          },
          [
            _c(
              "el-form",
              {
                ref: "form",
                staticStyle: { width: "100%", height: "100%" },
                attrs: {
                  model: _vm.form,
                  "label-width": "100px",
                  "label-position": "left",
                  "show-message": false
                }
              },
              [
                _c(
                  "el-collapse",
                  { staticStyle: { width: "100%", height: "100%" } },
                  [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          width: "100%",
                          height: "100%",
                          "min-width": "1000px",
                          display: "flex",
                          "flex-direction": "column"
                        }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "section",
                            staticStyle: {
                              width: "100%",
                              "min-height": "120px"
                            }
                          },
                          [
                            _c("span", { staticClass: "title" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("CargoMsg.Cargo_BankReceiptDetails")
                                )
                              )
                            ]),
                            _c(
                              "div",
                              {
                                staticClass: "form-row",
                                staticStyle: { "flex-direction": "row" }
                              },
                              [
                                _c(
                                  "el-form",
                                  {
                                    staticStyle: { "margin-right": "10px" },
                                    attrs: {
                                      "label-width": "100px",
                                      "label-position": "left",
                                      disabled: true
                                    }
                                  },
                                  [
                                    _c(
                                      "el-row",
                                      [
                                        _c(
                                          "el-col",
                                          { attrs: { span: 5 } },
                                          [
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: {
                                                  label: _vm.$t(
                                                    "CargoMsg.Cargo_SerialNoOfBankReceipt"
                                                  ),
                                                  prop: "actualAmountNo"
                                                }
                                              },
                                              [
                                                _c("el-input", {
                                                  staticClass: "input-i",
                                                  model: {
                                                    value:
                                                      _vm.form.actualAmountNo,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.form,
                                                        "actualAmountNo",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "form.actualAmountNo"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: {
                                                  label: _vm.$t(
                                                    "CargoMsg.Cargo_PaymentCompanyName"
                                                  ),
                                                  prop: "paymentCompany"
                                                }
                                              },
                                              [
                                                _c("el-input", {
                                                  staticClass: "input-i",
                                                  model: {
                                                    value:
                                                      _vm.form.paymentCompany,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.form,
                                                        "paymentCompany",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "form.paymentCompany"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: {
                                                  label: _vm.$t(
                                                    "CargoMsg.Cargo_CompanySReceivingBank"
                                                  ),
                                                  prop: "companyBank"
                                                }
                                              },
                                              [
                                                _c("el-input", {
                                                  staticClass: "input-i",
                                                  model: {
                                                    value: _vm.form.companyBank,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.form,
                                                        "companyBank",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "form.companyBank"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-col",
                                          { attrs: { span: 5 } },
                                          [
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: {
                                                  label: _vm.$t(
                                                    "CargoMsg.Cargo_PublishStatus"
                                                  ),
                                                  prop: "releaseState"
                                                }
                                              },
                                              [
                                                _c("el-input", {
                                                  staticClass: "input-i",
                                                  model: {
                                                    value:
                                                      _vm.form.releaseState,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.form,
                                                        "releaseState",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "form.releaseState"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: {
                                                  label: _vm.$t(
                                                    "CargoMsg.Cargo_CurrencyOfPayment"
                                                  ),
                                                  prop: "currency"
                                                }
                                              },
                                              [
                                                _c("el-input", {
                                                  staticClass: "input-i",
                                                  model: {
                                                    value: _vm.form.currency,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.form,
                                                        "currency",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "form.currency"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: {
                                                  label: _vm.$t(
                                                    "CargoMsg.Cargo_CompanySReceivingAccountNumber"
                                                  ),
                                                  prop: "companyBankAccount"
                                                }
                                              },
                                              [
                                                _c("el-input", {
                                                  staticClass: "input-i",
                                                  model: {
                                                    value:
                                                      _vm.form
                                                        .companyBankAccount,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.form,
                                                        "companyBankAccount",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "form.companyBankAccount"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-col",
                                          { attrs: { span: 5 } },
                                          [
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: {
                                                  label: _vm.$t(
                                                    "CargoMsg.Cargo_ClaimState"
                                                  ),
                                                  prop: "labState"
                                                }
                                              },
                                              [
                                                _c("el-input", {
                                                  staticClass: "input-i",
                                                  model: {
                                                    value: _vm.form.labState,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.form,
                                                        "labState",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "form.labState"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: {
                                                  label: _vm.$t(
                                                    "CargoMsg.Cargo_PaymentAmount"
                                                  ),
                                                  prop: "amount"
                                                }
                                              },
                                              [
                                                _c("el-input", {
                                                  staticClass: "input-i",
                                                  model: {
                                                    value: _vm.form.amount,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.form,
                                                        "amount",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "form.amount"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: {
                                                  label: _vm.$t(
                                                    "CargoMsg.Cargo_RemainingPledgedAmount"
                                                  ),
                                                  prop: "remainAmount"
                                                }
                                              },
                                              [
                                                _c("el-input", {
                                                  staticClass: "input-i",
                                                  model: {
                                                    value:
                                                      _vm.form.remainAmount,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.form,
                                                        "remainAmount",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "form.remainAmount"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "section",
                            staticStyle: {
                              padding: "6px 0 0 0",
                              width: "100%",
                              "flex-grow": "1"
                            }
                          },
                          [
                            _c("span", { staticClass: "title" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("CargoMsg.Cargo_ClaimInformation")
                                )
                              )
                            ]),
                            _c(
                              "div",
                              {
                                staticClass: "form-row",
                                staticStyle: { width: "100%", height: "100%" }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.pageMode === 1,
                                        expression: "pageMode === 1"
                                      }
                                    ],
                                    staticStyle: { height: "100%" }
                                  },
                                  [
                                    _c(
                                      "bank-slip-charge-query",
                                      {
                                        ref: "bankSlipWriteOffCharge",
                                        attrs: {
                                          identify: "bankSlipWriteOff",
                                          "view-source": "bankSlipWriteOff",
                                          "job-state-param": "WriteoffJobState",
                                          "charge-state-param":
                                            "WriteoffChargeState",
                                          "confirm-state-param":
                                            "WriteoffChargeConfirmState",
                                          "config-module": "1300",
                                          "is-ar":
                                            _vm.searchConditions
                                              .applicationStatus,
                                          oversea: _vm.searchConditions.oversea,
                                          "paid-off": 0,
                                          "show-billing-no": true,
                                          "show-invoice-no": true,
                                          "show-total-unverified-amount": true,
                                          "show-unverified-amount": true,
                                          "rate-field": "rate",
                                          "ar-field": "isReceivable",
                                          "total-type": "revenueAbs",
                                          "grid-config-module": "1300001"
                                        },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "searchAreaHeader",
                                            fn: function() {
                                              return [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "app-main-inner-row  extension-conditions-form",
                                                    staticStyle: {
                                                      "padding-bottom": "5px",
                                                      "margin-top": "-7px"
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass: "filters"
                                                      },
                                                      [
                                                        _c(
                                                          "el-form",
                                                          {
                                                            attrs: {
                                                              inline: true,
                                                              "label-width":
                                                                "60px",
                                                              "label-position":
                                                                "left"
                                                            }
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "el-form-item-wrapper dense-radio-group"
                                                              },
                                                              [
                                                                _c(
                                                                  "el-form-item",
                                                                  {
                                                                    staticClass:
                                                                      "dense-radio-group",
                                                                    attrs: {
                                                                      label: _vm.$t(
                                                                        "CargoMsg.Cargo_PaymentReceiveMethod"
                                                                      )
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "el-radio-group",
                                                                      {
                                                                        model: {
                                                                          value:
                                                                            _vm
                                                                              .searchConditions
                                                                              .applicationStatus,
                                                                          callback: function(
                                                                            $$v
                                                                          ) {
                                                                            _vm.$set(
                                                                              _vm.searchConditions,
                                                                              "applicationStatus",
                                                                              $$v
                                                                            )
                                                                          },
                                                                          expression:
                                                                            "searchConditions.applicationStatus"
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "el-radio",
                                                                          {
                                                                            attrs: {
                                                                              disabled: !(
                                                                                _vm.bankArSlip &&
                                                                                _vm.bankApSlip
                                                                              ),
                                                                              label: -1
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                _vm.$t(
                                                                                  "CargoMsg.Cargo_All"
                                                                                )
                                                                              )
                                                                            )
                                                                          ]
                                                                        ),
                                                                        _c(
                                                                          "el-radio",
                                                                          {
                                                                            attrs: {
                                                                              disabled: !_vm.bankArSlip,
                                                                              label: 1
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                _vm.$t(
                                                                                  "CargoMsg.Cargo_Receivable"
                                                                                )
                                                                              )
                                                                            )
                                                                          ]
                                                                        ),
                                                                        _c(
                                                                          "el-radio",
                                                                          {
                                                                            attrs: {
                                                                              disabled: !_vm.bankApSlip,
                                                                              label: 0
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                _vm.$t(
                                                                                  "CargoMsg.Cargo_Dues"
                                                                                )
                                                                              )
                                                                            )
                                                                          ]
                                                                        )
                                                                      ],
                                                                      1
                                                                    )
                                                                  ],
                                                                  1
                                                                ),
                                                                _c(
                                                                  "el-form-item",
                                                                  {
                                                                    staticClass:
                                                                      "dense-radio-group",
                                                                    attrs: {
                                                                      label: _vm.$t(
                                                                        "CargoMsg.Cargo_ChargeType"
                                                                      )
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "el-radio-group",
                                                                      {
                                                                        model: {
                                                                          value:
                                                                            _vm
                                                                              .searchConditions
                                                                              .oversea,
                                                                          callback: function(
                                                                            $$v
                                                                          ) {
                                                                            _vm.$set(
                                                                              _vm.searchConditions,
                                                                              "oversea",
                                                                              $$v
                                                                            )
                                                                          },
                                                                          expression:
                                                                            "searchConditions.oversea"
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "el-radio",
                                                                          {
                                                                            attrs: {
                                                                              label: -1
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                _vm.$t(
                                                                                  "CargoMsg.Cargo_All"
                                                                                )
                                                                              )
                                                                            )
                                                                          ]
                                                                        ),
                                                                        _c(
                                                                          "el-radio",
                                                                          {
                                                                            attrs: {
                                                                              label: 0
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                _vm.$t(
                                                                                  "CargoMsg.Cargo_Domestic"
                                                                                )
                                                                              )
                                                                            )
                                                                          ]
                                                                        ),
                                                                        _c(
                                                                          "el-radio",
                                                                          {
                                                                            attrs: {
                                                                              label: 1
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                _vm.$t(
                                                                                  "CargoMsg.Cargo_International"
                                                                                )
                                                                              )
                                                                            )
                                                                          ]
                                                                        )
                                                                      ],
                                                                      1
                                                                    )
                                                                  ],
                                                                  1
                                                                ),
                                                                _c(
                                                                  "el-form-item",
                                                                  {
                                                                    staticClass:
                                                                      "dense-radio-group",
                                                                    attrs: {
                                                                      label: _vm.$t(
                                                                        "CargoMsg.Cargo_MethodOfClaim"
                                                                      )
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "el-radio-group",
                                                                      {
                                                                        on: {
                                                                          change:
                                                                            _vm.modeChangeHandler
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            _vm
                                                                              .searchConditions
                                                                              .mode,
                                                                          callback: function(
                                                                            $$v
                                                                          ) {
                                                                            _vm.$set(
                                                                              _vm.searchConditions,
                                                                              "mode",
                                                                              $$v
                                                                            )
                                                                          },
                                                                          expression:
                                                                            "searchConditions.mode"
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "el-radio",
                                                                          {
                                                                            attrs: {
                                                                              label: 0
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                _vm.$t(
                                                                                  "CargoMsg.Cargo_Cost"
                                                                                )
                                                                              )
                                                                            )
                                                                          ]
                                                                        ),
                                                                        _c(
                                                                          "el-radio",
                                                                          {
                                                                            attrs: {
                                                                              label: 1
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                _vm.$t(
                                                                                  "CargoMsg.Cargo_Bill"
                                                                                )
                                                                              )
                                                                            )
                                                                          ]
                                                                        ),
                                                                        _c(
                                                                          "el-radio",
                                                                          {
                                                                            attrs: {
                                                                              label: 2
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                _vm.$t(
                                                                                  "CargoMsg.Cargo_Invoice"
                                                                                )
                                                                              )
                                                                            )
                                                                          ]
                                                                        )
                                                                      ],
                                                                      1
                                                                    )
                                                                  ],
                                                                  1
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          ]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ]
                                                )
                                              ]
                                            },
                                            proxy: true
                                          }
                                        ])
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            attrs: { slot: "operations" },
                                            slot: "operations"
                                          },
                                          [
                                            _c(
                                              "el-button",
                                              {
                                                attrs: { type: "primary" },
                                                on: {
                                                  click: _vm.bankSlipClickEvent
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "CargoMsg.Cargo_Claim"
                                                    )
                                                  )
                                                )
                                              ]
                                            ),
                                            _c(
                                              "el-button",
                                              {
                                                attrs: { type: "primary" },
                                                on: {
                                                  click: _vm.backClickHandler
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "CargoMsg.Cargo_Back"
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.pageMode === 2,
                                        expression: "pageMode === 2"
                                      }
                                    ],
                                    staticStyle: { height: "100%" }
                                  },
                                  [
                                    _c(
                                      "bank-slip-billing-query",
                                      {
                                        ref: "bankSlipWriteOffBilling",
                                        attrs: {
                                          identify: "bankSlipWriteOff",
                                          "view-source": "bankSlipWriteOff",
                                          "config-module": "1400",
                                          "billing-clearing-state-param":
                                            "WriteoffBillingClearingState",
                                          "billing-job-state-param":
                                            "WriteoffJobState",
                                          "billing-state-param":
                                            "WriteoffBillingState",
                                          "clearing-state": 0,
                                          "is-ar":
                                            _vm.searchConditions
                                              .applicationStatus,
                                          oversea: _vm.searchConditions.oversea,
                                          "show-real-clearing-state": true,
                                          "show-total-unverified-amount": true,
                                          "ar-field": "ar",
                                          "total-type": "revenueAbs",
                                          "page-mode": _vm.pageMode,
                                          "grid-config-module": "1400001"
                                        },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "searchAreaHeader",
                                            fn: function() {
                                              return [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "app-main-inner-row  extension-conditions-form",
                                                    staticStyle: {
                                                      "padding-bottom": "5px",
                                                      "margin-top": "-7px"
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass: "filters"
                                                      },
                                                      [
                                                        _c(
                                                          "el-form",
                                                          {
                                                            attrs: {
                                                              inline: true,
                                                              "label-width":
                                                                "60px",
                                                              "label-position":
                                                                "left"
                                                            }
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "el-form-item-wrapper dense-radio-group"
                                                              },
                                                              [
                                                                _c(
                                                                  "el-form-item",
                                                                  {
                                                                    staticClass:
                                                                      "dense-radio-group",
                                                                    attrs: {
                                                                      label: _vm.$t(
                                                                        "CargoMsg.Cargo_PaymentReceiveMethod"
                                                                      )
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "el-radio-group",
                                                                      {
                                                                        model: {
                                                                          value:
                                                                            _vm
                                                                              .searchConditions
                                                                              .applicationStatus,
                                                                          callback: function(
                                                                            $$v
                                                                          ) {
                                                                            _vm.$set(
                                                                              _vm.searchConditions,
                                                                              "applicationStatus",
                                                                              $$v
                                                                            )
                                                                          },
                                                                          expression:
                                                                            "searchConditions.applicationStatus"
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "el-radio",
                                                                          {
                                                                            attrs: {
                                                                              disabled: !(
                                                                                _vm.bankArSlip &&
                                                                                _vm.bankApSlip
                                                                              ),
                                                                              label: -1
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                _vm.$t(
                                                                                  "CargoMsg.Cargo_All"
                                                                                )
                                                                              )
                                                                            )
                                                                          ]
                                                                        ),
                                                                        _c(
                                                                          "el-radio",
                                                                          {
                                                                            attrs: {
                                                                              disabled: !_vm.bankArSlip,
                                                                              label: 1
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                _vm.$t(
                                                                                  "CargoMsg.Cargo_Receivable"
                                                                                )
                                                                              )
                                                                            )
                                                                          ]
                                                                        ),
                                                                        _c(
                                                                          "el-radio",
                                                                          {
                                                                            attrs: {
                                                                              disabled: !_vm.bankApSlip,
                                                                              label: 0
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                _vm.$t(
                                                                                  "CargoMsg.Cargo_Dues"
                                                                                )
                                                                              )
                                                                            )
                                                                          ]
                                                                        )
                                                                      ],
                                                                      1
                                                                    )
                                                                  ],
                                                                  1
                                                                ),
                                                                _c(
                                                                  "el-form-item",
                                                                  {
                                                                    staticClass:
                                                                      "dense-radio-group",
                                                                    attrs: {
                                                                      label: _vm.$t(
                                                                        "CargoMsg.Cargo_ChargeType"
                                                                      )
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "el-radio-group",
                                                                      {
                                                                        model: {
                                                                          value:
                                                                            _vm
                                                                              .searchConditions
                                                                              .oversea,
                                                                          callback: function(
                                                                            $$v
                                                                          ) {
                                                                            _vm.$set(
                                                                              _vm.searchConditions,
                                                                              "oversea",
                                                                              $$v
                                                                            )
                                                                          },
                                                                          expression:
                                                                            "searchConditions.oversea"
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "el-radio",
                                                                          {
                                                                            attrs: {
                                                                              label: -1
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                _vm.$t(
                                                                                  "CargoMsg.Cargo_All"
                                                                                )
                                                                              )
                                                                            )
                                                                          ]
                                                                        ),
                                                                        _c(
                                                                          "el-radio",
                                                                          {
                                                                            attrs: {
                                                                              label: 0
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                _vm.$t(
                                                                                  "CargoMsg.Cargo_Domestic"
                                                                                )
                                                                              )
                                                                            )
                                                                          ]
                                                                        ),
                                                                        _c(
                                                                          "el-radio",
                                                                          {
                                                                            attrs: {
                                                                              label: 1
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                _vm.$t(
                                                                                  "CargoMsg.Cargo_International"
                                                                                )
                                                                              )
                                                                            )
                                                                          ]
                                                                        )
                                                                      ],
                                                                      1
                                                                    )
                                                                  ],
                                                                  1
                                                                ),
                                                                _c(
                                                                  "el-form-item",
                                                                  {
                                                                    staticClass:
                                                                      "dense-radio-group",
                                                                    attrs: {
                                                                      label: _vm.$t(
                                                                        "CargoMsg.Cargo_MethodOfClaim"
                                                                      )
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "el-radio-group",
                                                                      {
                                                                        on: {
                                                                          change:
                                                                            _vm.modeChangeHandler
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            _vm
                                                                              .searchConditions
                                                                              .mode,
                                                                          callback: function(
                                                                            $$v
                                                                          ) {
                                                                            _vm.$set(
                                                                              _vm.searchConditions,
                                                                              "mode",
                                                                              $$v
                                                                            )
                                                                          },
                                                                          expression:
                                                                            "searchConditions.mode"
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "el-radio",
                                                                          {
                                                                            attrs: {
                                                                              label: 0
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                _vm.$t(
                                                                                  "CargoMsg.Cargo_Cost"
                                                                                )
                                                                              )
                                                                            )
                                                                          ]
                                                                        ),
                                                                        _c(
                                                                          "el-radio",
                                                                          {
                                                                            attrs: {
                                                                              label: 1
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                _vm.$t(
                                                                                  "CargoMsg.Cargo_Bill"
                                                                                )
                                                                              )
                                                                            )
                                                                          ]
                                                                        ),
                                                                        _c(
                                                                          "el-radio",
                                                                          {
                                                                            attrs: {
                                                                              label: 2
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                _vm.$t(
                                                                                  "CargoMsg.Cargo_Invoice"
                                                                                )
                                                                              )
                                                                            )
                                                                          ]
                                                                        )
                                                                      ],
                                                                      1
                                                                    )
                                                                  ],
                                                                  1
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          ]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ]
                                                )
                                              ]
                                            },
                                            proxy: true
                                          }
                                        ])
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            attrs: { slot: "operations" },
                                            slot: "operations"
                                          },
                                          [
                                            _c(
                                              "el-button",
                                              {
                                                attrs: { type: "primary" },
                                                on: {
                                                  click: _vm.bankSlipClickEvent
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "CargoMsg.Cargo_Claim"
                                                    )
                                                  )
                                                )
                                              ]
                                            ),
                                            _c(
                                              "el-button",
                                              {
                                                attrs: { type: "primary" },
                                                on: {
                                                  click: _vm.backClickHandler
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "CargoMsg.Cargo_Back"
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.pageMode === 3,
                                        expression: "pageMode === 3"
                                      }
                                    ],
                                    staticStyle: {
                                      height: "100%",
                                      display: "flex",
                                      "flex-direction": "column"
                                    }
                                  },
                                  [
                                    _c(
                                      "bank-slip-invoice-query",
                                      {
                                        ref: "bankSlipWriteOffInvoice",
                                        attrs: {
                                          identify: "bankSlipWriteOff",
                                          "view-source": "bankSlipWriteOff",
                                          "config-module": "1401",
                                          "billing-clearing-state-param":
                                            "WriteoffBillingClearingState",
                                          "billing-job-state-param":
                                            "WriteoffJobState",
                                          "billing-state-param":
                                            "WriteoffBillingState",
                                          "clearing-state": 0,
                                          "is-ar":
                                            _vm.searchConditions
                                              .applicationStatus,
                                          oversea: _vm.searchConditions.oversea,
                                          "show-real-clearing-state": true,
                                          "show-total-unverified-amount": true,
                                          "total-type": "auto",
                                          "page-mode": _vm.pageMode,
                                          "grid-config-module": "190606",
                                          "invoice-no-state": 1,
                                          "show-charge-count": true,
                                          "show-unverified-amount": true,
                                          "show-fba": false,
                                          "always-show": false,
                                          "new-currency-code": true,
                                          "show-wht": true,
                                          type: "both"
                                        },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "searchAreaHeader",
                                            fn: function() {
                                              return [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "app-main-inner-row  extension-conditions-form",
                                                    staticStyle: {
                                                      "padding-bottom": "5px",
                                                      "margin-top": "-7px"
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass: "filters"
                                                      },
                                                      [
                                                        _c(
                                                          "el-form",
                                                          {
                                                            attrs: {
                                                              inline: true,
                                                              "label-width":
                                                                "60px",
                                                              "label-position":
                                                                "left"
                                                            }
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "el-form-item-wrapper dense-radio-group"
                                                              },
                                                              [
                                                                _c(
                                                                  "el-form-item",
                                                                  {
                                                                    staticClass:
                                                                      "dense-radio-group",
                                                                    attrs: {
                                                                      label: _vm.$t(
                                                                        "CargoMsg.Cargo_PaymentReceiveMethod"
                                                                      )
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "el-radio-group",
                                                                      {
                                                                        model: {
                                                                          value:
                                                                            _vm
                                                                              .searchConditions
                                                                              .applicationStatus,
                                                                          callback: function(
                                                                            $$v
                                                                          ) {
                                                                            _vm.$set(
                                                                              _vm.searchConditions,
                                                                              "applicationStatus",
                                                                              $$v
                                                                            )
                                                                          },
                                                                          expression:
                                                                            "searchConditions.applicationStatus"
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "el-radio",
                                                                          {
                                                                            attrs: {
                                                                              disabled: !(
                                                                                _vm.bankArSlip &&
                                                                                _vm.bankApSlip
                                                                              ),
                                                                              label: -1
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                _vm.$t(
                                                                                  "CargoMsg.Cargo_All"
                                                                                )
                                                                              )
                                                                            )
                                                                          ]
                                                                        ),
                                                                        _c(
                                                                          "el-radio",
                                                                          {
                                                                            attrs: {
                                                                              disabled: !_vm.bankArSlip,
                                                                              label: 1
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                _vm.$t(
                                                                                  "CargoMsg.Cargo_Receivable"
                                                                                )
                                                                              )
                                                                            )
                                                                          ]
                                                                        ),
                                                                        _c(
                                                                          "el-radio",
                                                                          {
                                                                            attrs: {
                                                                              disabled: !_vm.bankApSlip,
                                                                              label: 0
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                _vm.$t(
                                                                                  "CargoMsg.Cargo_Dues"
                                                                                )
                                                                              )
                                                                            )
                                                                          ]
                                                                        )
                                                                      ],
                                                                      1
                                                                    )
                                                                  ],
                                                                  1
                                                                ),
                                                                _c(
                                                                  "el-form-item",
                                                                  {
                                                                    staticClass:
                                                                      "dense-radio-group",
                                                                    attrs: {
                                                                      label: _vm.$t(
                                                                        "CargoMsg.Cargo_MethodOfClaim"
                                                                      )
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "el-radio-group",
                                                                      {
                                                                        on: {
                                                                          change:
                                                                            _vm.modeChangeHandler
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            _vm
                                                                              .searchConditions
                                                                              .mode,
                                                                          callback: function(
                                                                            $$v
                                                                          ) {
                                                                            _vm.$set(
                                                                              _vm.searchConditions,
                                                                              "mode",
                                                                              $$v
                                                                            )
                                                                          },
                                                                          expression:
                                                                            "searchConditions.mode"
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "el-radio",
                                                                          {
                                                                            attrs: {
                                                                              label: 0
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                _vm.$t(
                                                                                  "CargoMsg.Cargo_Cost"
                                                                                )
                                                                              )
                                                                            )
                                                                          ]
                                                                        ),
                                                                        _c(
                                                                          "el-radio",
                                                                          {
                                                                            attrs: {
                                                                              label: 1
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                _vm.$t(
                                                                                  "CargoMsg.Cargo_Bill"
                                                                                )
                                                                              )
                                                                            )
                                                                          ]
                                                                        ),
                                                                        _c(
                                                                          "el-radio",
                                                                          {
                                                                            attrs: {
                                                                              label: 2
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                _vm.$t(
                                                                                  "CargoMsg.Cargo_Invoice"
                                                                                )
                                                                              )
                                                                            )
                                                                          ]
                                                                        )
                                                                      ],
                                                                      1
                                                                    )
                                                                  ],
                                                                  1
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          ]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ]
                                                )
                                              ]
                                            },
                                            proxy: true
                                          }
                                        ])
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            attrs: { slot: "operations" },
                                            slot: "operations"
                                          },
                                          [
                                            _c(
                                              "el-button",
                                              {
                                                attrs: { type: "primary" },
                                                on: {
                                                  click: _vm.bankSlipClickEvent
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "CargoMsg.Cargo_Claim"
                                                    )
                                                  )
                                                )
                                              ]
                                            ),
                                            _c(
                                              "el-button",
                                              {
                                                attrs: { type: "primary" },
                                                on: {
                                                  click: _vm.backClickHandler
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "CargoMsg.Cargo_Back"
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ]
                            )
                          ]
                        )
                      ]
                    )
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _c("bank-slip-window", {
        attrs: {
          visible: _vm.bankSlipWindow.visible,
          "is-pre-payment": _vm.bankSlipWindow.isPrePayment,
          params: _vm.bankSlipWindow.params,
          ar: true
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.bankSlipWindow, "visible", $event)
          },
          refresh: _vm.refreshPageHandler
        }
      }),
      _vm.writeOffDialog.visible
        ? _c("write-off-dialog", {
            ref: "dgWriteOff",
            attrs: {
              location: _vm.location,
              visible: _vm.writeOffDialog.visible,
              title: _vm.writeOffDialog.title,
              params: _vm.writeOffDialog.params,
              properties: _vm.writeOffDialog.properties
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.writeOffDialog, "visible", $event)
              },
              writeoffSuccessHandler: _vm.writeOffSuccessHandler
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }